import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: {
      name: 'login'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../page/login.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../page/home.vue')
  },
  {
    path: '/myAppointment',
    name: 'myAppointment',
    component: () => import('../page/myAppointment.vue')
  },
  {
    path: '/appointmentDetails/:id',
    name: 'appointmentDetails',
    component: () => import('../page/appointmentDetails.vue')
  },
  {
    path: '/record',
    name: 'record',
    component: () => import('../page/recordList.vue')
  },
  {
    path: '/recordDetails/:id',
    name: 'recordDetails',
    component: () => import('../page/recordDetails.vue')
  },
  {
    path: '/breastReport/:id',
    name: 'breastReport',
    component: () => import('../page/breastReport.vue')
  },
  {
    // 触诊(乳腺)
    path: '/breast/palpationReport/:id',
    name: 'palpationReport',
    component: () => import('../page/components/breast/palpationReport.vue')
  },
  {
    // 超声(乳腺)
    path: '/breast/ultrasonicReport/:id',
    name: 'ultrasonicReport',
    component: () => import('../page/components/breast/ultrasonicReport.vue')
  },
  {
    // 钼靶(乳腺)
    path: '/breast/mammographyReport/:id',
    name: 'mammographyReport',
    component: () => import('../page/components/breast/mammographyReport.vue')
  },
  {
    // 核磁(乳腺)
    path: '/breast/MRReport/:id',
    name: 'MRReport',
    component: () => import('../page/components/breast/MRReport.vue')
  },
  {
    // 乳管镜(乳腺)
    path: '/breast/breastDuctmicroscopy/:id',
    name: 'breastDuctmicroscopy',
    component: () => import('../page/components/breast/breastDuctmicroscopy.vue')
  },
  {
    // 其他(乳腺)
    path: '/breast/otherReport/:id',
    name: 'otherReport',
    component: () => import('../page/components/breast/otherReport.vue')
  },
  {
    // 病理(乳腺)
    path: '/breast/pathologyReport/:id',
    name: 'breastPathologyReport',
    component: () => import('../page/components/breast/pathologyReport.vue')
  },
  {
    path: '/cervicalReport/:id',
    name: 'cervicalReport',
    component: () => import('../page/cervicalReport.vue')
  },
  {
    // 妇科(宫颈)
    path: '/cervical/gynecologyReport/:id',
    name: 'gynecologyReport',
    component: () => import('../page/components/cervical/gynecologyReport')
  },
  {
    // HPV(宫颈)
    path: '/cervical/HPVReport/:id',
    name: 'HPVReport',
    component: () => import('../page/components/cervical/HPVReport')
  },
  {
    // 细胞学(宫颈)
    path: '/cervical/cellReport/:id',
    name: 'cellReport',
    component: () => import('../page/components/cervical/cellReport')
  },
  {
    // VIA/VILI(宫颈)
    path: '/cervical/VIAReport/:id',
    name: 'VIAReport',
    component: () => import('../page/components/cervical/VIAReport')
  },
  {
    // 阴道镜(宫颈)
    path: '/cervical/colposcopeReport/:id',
    name: 'colposcopeReport',
    component: () => import('../page/components/cervical/colposcopeReport')
  },
  {
    // 病理(宫颈)
    path: '/cervical/pathologyReport/:id',
    name: 'cervicalPathologyReport',
    component: () => import('../page/components/cervical/pathologyReport')
  },
  {
    path: '/bgDetails/',
    name: 'bgDetails',
    component: () => import('../page/bgDetails.vue')
  },
  {
    path: '/doctorList',
    name: 'doctorList',
    component: () => import('../page/doctorList.vue')
  },
  {
    path: '/fxpg',
    name: 'fxpg',
    component: () => import('../page/fxpg.vue')
  },
  {
    path: '/jcbg/:id',
    name: 'jcbg',
    component: () => import('../page/jcbg.vue')
  },
  {
    path: '/upload/:blId/:id/:type?',
    name: 'upload',
    component: () => import('../page/upload.vue')
  },
  {
    path: '/msgList',
    name: 'msgList',
    component: () => import('../page/msgList.vue')
  },
  {
    path: '/msgDetails/:id',
    name: 'msgDetails',
    component: () => import('../page/msgDetails.vue')
  },
  {
    path: '/kepu',
    name: 'kepuList',
    component: () => import('../page/kepuList.vue')
  },
  {
    path: '/kepu/:id',
    name: 'kepuListType',
    component: () => import('../page/kepuList.vue')
  },
  {
    path: '/kepuDetails/:id',
    name: 'kepuDetails',
    component: () => import('../page/kepuDetails.vue')
  },
  {
    path: '/subscribeList/:insId',
    name: 'subscribeList',
    component: () => import('../page/subscribeList.vue')
  },
  {
    path: '/subscribeDetails/:type/:timeType/:institutionId/:subscribeId/:addressCode',
    name: 'subscribeDetails',
    component: () => import('../page/subscribeDetails.vue')
  },
  {
    path: '/tips/:id',
    name: 'tips',
    component: () => import('../page/tips.vue')
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('../page/newAgreement.vue')
  },
  {
    path: '/agreement/claimsNotice',
    name: 'claims',
    component: () => import('../page/claimsNotice')
  },
  {
    // 查看知情同意书
    path: '/viewAgreement/:id',
    name: 'viewAgreement',
    component: () => import('../page/viewAgreement')
  },
  {
    path: '/question',
    name: 'question',
    component: () => import('../page/newQuestion')
  },
  {
    path: '/notice/:type/:timeType/:institutionId/:subscribeId/:addressCode',
    name: 'notice',
    component: () => import('../page/newNotice.vue')
  },
  {
    path: '/tips_1/:insId',
    name: 'tips_1',
    component: () => import('../page/tips_1.vue')
  },
  {
    path: '/poster',
    name: 'poster1',
    component: () => import('../page/poster.vue')
  },
  {
    path: '/poster/:insId',
    name: 'poster',
    component: () => import('../page/poster.vue')
  },

  {
    path: '/unpublished',
    name: 'unpublished',
    component: () => import('../page/unpublished.vue')
  },
  {
    path: '/insIntro',
    name: 'insIntro',
    component: () => import('../page/insIntro.vue')
  },
  {
    path: '/shareReport',
    name: 'shareReport',
    component: () => import('../page/shareReport.vue')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach(function (to, from, next) {
  if (to.name === 'tips_1') {
    const oldStartTime = new Date().getTime()
    const startTime = new Date('2020-05-20 00:00:00').getTime()
    if (oldStartTime >= startTime) return next(`/subscribeList/${to.params.insId}`)
  } else if (to.name === 'poster1') {
    return next('/poster/34')
  } else if ((from.name === 'appointmentDetails' && to.name === 'question') || (from.name === 'appointmentDetails' && to.name === 'agreement')) {
    return next(`/subscribeList/${JSON.parse(localStorage.getItem('userData')).insId}`)
  }
  next()
})

export default router
